import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const IntellectualProperty = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Intellectual Property</h3>
      <p>
        All content on the platform, including but not limited to courses,
        quizzes, certificates, newsletters, trademarks, logos, and branding, is
        the exclusive property of Yoda Safety Services. This content is
        protected by copyright, trademark, and other intellectual property laws.
      </p>
      <h4>Limited License</h4>
      <p>
        Users are granted a limited, non-exclusive, non-transferable license to
        access and use the content for personal or professional development
        purposes. This license does not permit:
      </p>
      <ul>
        <li>
          Copying, distributing, or modifying the content without authorization.
        </li>
        <li>Reselling or redistributing access to the content.</li>
        <li>
          Using the content for commercial purposes without prior written
          consent.
        </li>
        <li>Altering or falsifying certificates of completion.</li>
      </ul>
      <h4>Restrictions</h4>
      <p>Users are prohibited from:</p>
      <ul>
        <li>
          Sharing login credentials or granting access to unauthorized
          individuals.
        </li>
        <li>Reproducing or distributing quiz questions or answers.</li>
        <li>
          Using newsletters or promotional content for unauthorized purposes.
        </li>
      </ul>
      <h4>Enforcement</h4>
      <p>
        Violations of these terms may result in the suspension or termination of
        your account and, where applicable, legal action. If you believe your
        intellectual property rights have been violated, please contact us at{' '}
        <a href="mailto:yodasafetyservices1@outlook.com">
          yodasafetyservices1@outlook.com
        </a>
        .
      </p>
    </PrivacyPolicyContainer>
  );
};

export default IntellectualProperty;
